module.exports = __webpack_public_path__ + "static/media/cross-white.32b210a8.svg";